/* eslint-disable lingui/text-restrictions */

import {  t  } from "@/client/libs/dummy-i18n";

import { DEFAULT_MAX_TOKENS, DEFAULT_MODEL } from "@/client/constants/llm";
import { axios } from "@/client/libs/axios";
import { useAuthStore } from "@/client/stores/auth";
import { useOpenAiStore } from "@/client/stores/openai";

import { openai } from "./client";

const PROMPT = `You are an AI writing assistant specialized in writing copy for resumes.
Do not return anything else except the text you improved. It should not begin with a newline. It should not have any prefix or suffix text.
Improve the writing of the following paragraph and returns in the language of the text:

Text: """{input}"""

Revised Text: """`;

export const improveWriting = async (text: string) => {
  const prompt = PROMPT.replace("{input}", text);

  const { apiKey, model, maxTokens } = useOpenAiStore.getState();
  const { user } = useAuthStore.getState();

  if (apiKey) {
    const result = await openai().chat.completions.create({
      messages: [{ role: "user", content: prompt }],
      model: model ?? DEFAULT_MODEL,
      max_tokens: maxTokens ?? DEFAULT_MAX_TOKENS,
      temperature: 0,
      stop: ['"""'],
      n: 1,
    });

    if (result.choices.length === 0) {
      throw new Error(t`OpenAI did not return any choices for your text.`);
    }

    return result.choices[0].message.content ?? text;
  }

  if (user?.isPremium) {
    const { data } = await axios.post<string>("/ai/improve", { text });
    return data;
  }

  throw new Error(t`Please upgrade to Premium or set your own OpenAI API Key in settings.`);
};
